<template>
    <div>
        <div class="d-flex align-items-center text-align justify-content-center" 
            style="height: 300px; flex-direction: column"
            v-if="loadingInitial">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <br>
            <p class="mt-2">Loading</p>
        </div>

        <form @submit.prevent="submitForm()" v-else>
            <div class="text-center">
                <button type="button" 
                @click="$refs.file.click()"
                class="btn btn-primary" v-if="dataInstance.logo == '' || dataInstance.logo == null || dataInstance.logo == '[]'">
                Upload Image</button>
            </div>

            <div class="text-center mb-30" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <img :src="dataInstance.logo" alt="" style="width: 100px;height: 100px;object-fit:cover;border:1px solid #ddd;border-radius:10px;cursor:pointer"
                @click="$refs.file.click()">
                <input type="file" ref="file" style="display:none" @change="changeImage" accept="image/png, image/jpg, image/jpeg">
            </div>

            <div class="d-flex mt-5" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <img :src="dataInstance.logoPrint" alt="" style="width: 100px;height: 100px;object-fit:cover;border:1px solid #ddd;border-radius:10px;cursor:pointer">

                <div class="div ml-3">
                    <label for="example-text-input" class="col-form-label text-left d-block">Logo Print</label>
                    <input type="file" class="form-control" @change="changeLogoPrint" id="upload-logo-print">
                </div>
            </div>

            <div class="form-group" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <label for="example-text-input" class="col-form-label text-left d-block">Nama Instansi</label>
                <input type="text" class="form-control" v-model="dataInstance.name">
            </div>
            
            <div class="form-group" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <label for="example-text-input" class="col-form-label text-left d-block">Alamat Instansi</label>
                <input type="text" class="form-control" v-model="dataInstance.address" required>
            </div>

            <div class="form-group" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <label for="example-text-input" class="col-form-label text-left d-block">Nama Bank</label>
                <input type="text" class="form-control" v-model="dataInstance.bank_name" required>
            </div>

            <div class="form-group" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <label for="example-text-input" class="col-form-label text-left d-block">Nama Cabang Bank</label>
                <input type="text" class="form-control" v-model="dataInstance.bank_branch_name" required>
            </div>

            <div class="form-group" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <label for="example-text-input" class="col-form-label text-left d-block">Nomor Rekening Bank 1</label>
                <input type="text" class="form-control" v-model="dataInstance.bank_account_number" required>
            </div>

            <div class="form-group" v-if="$store.state.permission.includes('company.setting.mandatory')">
                <label for="example-text-input" class="col-form-label text-left d-block">Nomor Rekening Bank 2</label>
                <input type="text" class="form-control" v-model="dataInstance.bank_account_number_2" required>
            </div>

            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Nama</label>
                <input type="text" class="form-control" v-model="dataInstance.name_user" required>
            </div>

            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Username</label>
                <input type="text" class="form-control" v-model="dataInstance.username" required>
            </div>

            <div class="form-check form-group mb-0 mt-3">
                <input class="form-check-input" type="checkbox" v-model="editPass" id="defaultCheck1">
                <label class="form-check-label" for="defaultCheck1" style="margin-top: 1px;">
                    Apakah anda ingin mengedit password ?
                </label>
            </div>

            <div class="form-group mb-0" v-if="editPass" :class="{ 'is-invalid': $v.dataInstance.old_password.$error }">
                <label for="example-text-input" class="col-form-label text-left d-block">Kata Sandi Sebelumnya</label>
                <input type="password" class="form-control" v-model="dataInstance.old_password" :required="editPass">
                <div class="error" v-if="!$v.dataInstance.old_password.required">Kata Sandi wajib diisi</div>
            </div>

            <div class="form-group mb-0" v-if="editPass" :class="{ 'is-invalid': $v.dataInstance.password.$error }">
                <label for="example-text-input" class="col-form-label text-left d-block">Kata Sandi Baru</label>
                <input type="password" class="form-control" v-model="dataInstance.password" :required="editPass">
                <div class="error" v-if="!$v.dataInstance.password.required">Kata Sandi baru wajib diisi</div>
                <div class="error" v-if="!$v.dataInstance.password.password">Kata Sandi baru harus terdiri dari minimal 8 karakter, huruf besar, huruf kecil, angka dan symbol. karakter </div>
            </div>

            <button class="btn btn-success waves-effect waves-light mt-4" :disabled="loading">
                Simpan
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </form>
    </div>
</template>

<script>
import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
const passwordRegex = helpers.regex('password', /^(?=.*[!@#$%^&*-])(?=.*[0-9])(?=.*[A-Z]).{8,20}$/)

export default {
    data() {
        return {
            loading: false,
            loadingInitial: true,
            companyID: '',
            editPass: false,
            dataInstance: {
                address: '',
                logo: null,
                fileLogo: '',
                logoPrint: null,
                fileLogoPrint: null,
                company_code: '',
                va_prefix: '',
                bank_account_number: null,
                bank_account_number_2: null,
                bank_branch_name: null,
                bank_name: null,
                name: '',
                name_user: '',
                username: '',
                password: null,
                old_password: null
            }
        }
    },
    validations() {
        return {
            dataInstance: {
                old_password: {
                    required
                },
                password: {
                    passwordRegex,
                    required
                },
            }
        }
    },
    methods: {
        changeImage(event){
            if(this.validationImage(event.target.files[0])){ 
                document.getElementById('upload-logo').value = ""
                this.labelLogo = 'Pilih File ...'
                return
            }

            this.dataInstance.fileLogo = event.target.files[0]
            this.dataInstance.logo = URL.createObjectURL(event.target.files[0])
        },
        changeLogoPrint(event){
            if(this.validationImage(event.target.files[0])){ 
                document.getElementById('upload-logo-print').value = ""
                this.labelLogoPrint = 'Pilih File ...'
                return
            }

            this.dataInstance.fileLogoPrint = event.target.files[0]
            this.dataInstance.logoPrint = URL.createObjectURL(event.target.files[0])
        },
        async loadInitialData() {
            this.loadingInitial = true;
    
            // GET COMPANY SETTING
            const companySetting = await this.$http.get(`${this.API_URL}company-setting`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            const companyForm = await this.$http.get(`${this.API_URL}company/${companySetting.data.data.company_id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            this.companyID = companySetting.data.data.company_id
            console.log(companyForm.data.data.company_code_access);
            this.dataInstance = {
                address: companyForm.data.data.address,
                logo: companyForm.data.data.logo,
                fileLogo: '',
                logoPrint: companyForm.data.data.logo_print,
                fileLogoPrint: '',
                va_prefix: companyForm.data.data.va_prefix,
                company_code: companyForm.data.data.company_code,
                company_code_access: companyForm.data.data.company_code_access,
                bank_name: companyForm.data.data.bank_name,
                bank_branch_name: companyForm.data.data.bank_branch_name,
                bank_account_number: companyForm.data.data.bank_account_number,
                bank_account_number_2: companyForm.data.data.bank_account_number_2,
                name: companyForm.data.data.name,
                is_transaction: companyForm.data.data.is_transaction,
                is_billing: companyForm.data.data.is_billing,
                is_sim: companyForm.data.data.is_sim,
                is_use_approval: companyForm.data.data.is_use_approval,

                name_user: this.$store.state.userData.name,
                username: this.$store.state.userData.username,
                password: null,
                old_password: null,
            }

            this.loadingInitial = false;
        },
        async submitForm() {
            this.loading = true

            let form = new FormData()
            form.append('address', this.dataInstance.address);
            form.append('logo', this.dataInstance.fileLogo ? this.dataInstance.fileLogo : null);
            form.append('logo_print', this.dataInstance.fileLogoPrint ? this.dataInstance.fileLogoPrint : null);
            form.append('name', this.dataInstance.name);
            form.append('va_prefix', this.dataInstance.va_prefix);
            form.append('bank_account_number', this.dataInstance.bank_account_number);
            form.append('bank_account_number_2', this.dataInstance.bank_account_number_2);
            form.append('bank_branch_name', this.dataInstance.bank_branch_name);
            form.append('bank_name', this.dataInstance.bank_name);
            form.append('company_code', this.dataInstance.company_code);
            form.append('company_code_access', this.dataInstance.company_code_access);
            form.append('is_transaction', this.dataInstance.is_transaction);
            form.append('is_billing', this.dataInstance.is_billing);
            form.append('is_sim', this.dataInstance.is_sim);
            form.append('is_use_approval', this.dataInstance.is_use_approval);
            // form.append('_method', 'PUT');

            let storeUser

            if(this.editPass){
                if (this.$v.dataInstance.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    this.loading = false
                    return
                }

                storeUser = {
                    name: this.dataInstance.name_user,
                    username: this.dataInstance.username,
                    old_password: this.dataInstance.old_password,
                    password: this.dataInstance.password,
                    password_confirmation: this.dataInstance.password,
                }
            }else{
                storeUser = {
                    name: this.dataInstance.name_user,
                    username: this.dataInstance.username,
                }
            }

            this.$http.post(`${this.API_URL}company/user/update/${this.$store.state.userData.id}`, storeUser, {
                headers: { 
                    'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                }
            }).then(() => {
                this.$http.post(`${this.API_URL}company/update/${this.companyID}`, form, {
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                })
                .then(response => {
                    const result = response.data;
                    
                    if(result.success) {
                        this.sAlert('success', "Berhasil mengupdate profile!")
                        // this.loadInitialData()
                        setTimeout(() => {
                            // this.$router.go()
                        }, 500);
                    }else {
                        this.sAlert('error', result.message)
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', error.response.data.message)
                });
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', error.response.data.message)
            });
            
            
        }
    },
    mounted() {
        this.loadInitialData()
    }
}
</script>

<style>

</style>